import React from 'react'
import CommentBubble from './CommentBubble'

const CommentLevels = () => {
    return (
        <div className="comment-level1">
            <CommentBubble/>
            <div className="comment-level2">
                <CommentBubble/>
                <div className="comment-level3">
                    <CommentBubble/>
                </div>
            </div>
            <div className="comment-level2">
                <CommentBubble/>
                <div className="comment-level3">
                    <CommentBubble/>
                    <CommentBubble/>
                </div>
            </div>
        </div>
    )
}

export default CommentLevels
